import {Component, Input, OnInit} from '@angular/core';
import {DonatedObject} from "../../models/DonatedObject";
import {Fossil} from "../../models/Fossil";
import {NameValuePair} from "../../models/NameValuePair";
import {APIService} from "../../service/api.service";
import {KKCD} from "../../models/KKCD";
import {AuthenticationService} from "../../service/AuthenticationService";

@Component({
  selector: 'app-song',
  templateUrl: './song.component.html',
  styleUrls: ['./song.component.scss']
})
export class SongComponent implements OnInit {

  @Input() collectedList: DonatedObject[] = [];
  @Input() uid: string;
  @Input() isShowTitle: boolean = true;
  isLoading = true;
  type = '';
  data: KKCD[] = [];
  filterList: NameValuePair[] = [];

  constructor(service: AuthenticationService, protected apiService: APIService) {
    if (this.uid == null) {
      this.uid = service.getUid();
    }
  }

  getFilterList(): NameValuePair[] {
    return [];
  }

  ngOnInit(): void {
    this.filterList = this.getFilterList();
    this.loadItems();
  }

  itemClicked(data) {
    console.log(data);
  }

  filterChanged(type) {
    this.type = type;
    this.loadItems();
  }

  handleCustomCollected(collectedList: DonatedObject[], item_id: string, key?: string): DonatedObject {
    for (let d of collectedList) {
      if (key != null) {
        if (d.collected_key == key && item_id == d.item_id) {
          return d;
        }
      } else {
        if (item_id == d.item_id) {
          return d;
        }
      }
    }
    return null;
  }

  protected loadItems() {
    this.isLoading = true;
    this.apiService.getKKCD(this.uid, this.isShowTitle ? '' : KKCD.KEY).subscribe(animals => {
      this.data = [];
      for (let a of animals) {
        let animal = new KKCD(a);
        animal.donatedObject = this.handleCustomCollected(this.collectedList, animal.id.toString(), KKCD.KEY);
        this.data.push(animal);
      }
    }, null, () => {
      this.isLoading = false;
    });
  }
}
